export type FarmFileKind = 'image' | 'pdf' | 'excel' | 'other';

const IMAGE_EXT = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'];
const EXCEL_EXT = ['xlsx', 'xls', 'xlsm', 'csv'];

export function getFileKind(fileName: string): FarmFileKind {
  const ext = (fileName || '').split('.').pop().toLowerCase();
  if (IMAGE_EXT.includes(ext)) return 'image';
  if (ext === 'pdf') return 'pdf';
  if (EXCEL_EXT.includes(ext)) return 'excel';
  return 'other';
}
